@if (location==='side') {
  <div class="menu-container-side" [ngClass]="{'force-side-menu-open': forceShowMenu === true}" [style.width]="(opened || forceShowMenu) ? '256px' : '60px'">
    <div class="menu-header">
      @if (opened || forceShowMenu) {
        <img class="menu-logo">
      }
      <div class="menu-button" [ngClass]="{'closed': !opened && !forceShowMenu}" (click)="onMenuToggleClick()">
        @if (!opened && !forceShowMenu) {
          <mat-icon class="menu-button-icon">menu</mat-icon>
        }
        @if (opened && !forceShowMenu) {
          <mat-icon class="menu-button-icon">menu_open</mat-icon>
        }
        @if (forceShowMenu) {
          <mat-icon class="menu-button-icon">close</mat-icon>
        }
      </div>
    </div>
    @if (user !== '' && opened) {
      <div class="user-info">
        <table>
          <tr>
            <td>
              <div class="user-img-container">
                <div class="user-initial">{{userInitials}}</div>
              </div>
            </td>
            <td>
              <table>
                <tr>
                  <td class="user-name">
                    {{user}}
                  </td>
                </tr>
                <tr>
                  <td class="user-email">
                    {{email}}
                  </td>
                </tr>
              </table>
            </td>
          </tr>
        </table>
      </div>
    }
    @if (user !== '' && !opened) {
      <div class="user-info user-info-small">
        <div class="user-img-container user-img-container-small">
          <div class="user-initial user-initial-small">{{userInitials}}</div>
        </div>
      </div>
    }
    <div class="menu-option" [ngClass]="{'selected': selectedMenu.item.id===myreportsMenu.id}" (click)="onMenuItemSelected(myreportsMenu)">
      <table width="256px">
        <tr>
          <td style="width:47px">
            <mat-icon class="menu-option-icon">{{myreportsMenu.icon}}</mat-icon>
          </td>
          @if (opened || forceShowMenu) {
            <td class="menu-option-text">
              {{myreportsMenu.title}}
            </td>
          }
        </tr>
      </table>
    </div>
    <mat-accordion class="menu-accordion">
      @for (menu of menus; track menu) {
        <div class="expansion-panel-wrapper">
          @if (menu.items.length===0) {
            <div class="menu-option" [ngClass]="{'selected': selectedMenu.item.id===menu.id}" (click)="onMenuItemSelected(menu)">
              <table width="256px">
                <tr>
                  <td style="width:47px">
                    <mat-icon class="menu-option-icon">{{menu.icon}}</mat-icon>
                  </td>
                  @if (opened || forceShowMenu) {
                    <td class="menu-option-text">
                      {{menu.title}}
                    </td>
                  }
                </tr>
              </table>
            </div>
          }
          @if (menu.items.length>0) {
            <mat-expansion-panel
              class="mat-elevation-z0"
              hideToggle
              [expanded]="getExpansionPanelState(menu)"
              (click)="onExpansionMenuClicked(menu)"
              (opened)="onExpansionMenuOpened(menu)"
              (closed)="onExpansionMenuClosed(menu)">
              <mat-expansion-panel-header class="menu-option" [ngClass]="{'selected': opened===false && selectedMenu.category.id===menu.id && !forceShowMenu}">
                <mat-panel-title class="menu-option" [ngClass]="{'selected': opened===false && selectedMenu.category.id===menu.id && !forceShowMenu}">
                  <table width="256px">
                    <tr>
                      <td style="width:47px">
                        <mat-icon class="menu-option-icon">{{menu.icon}}</mat-icon>
                      </td>
                      @if (opened || forceShowMenu) {
                        <td class="menu-option-text">
                          {{menu.title}}
                        </td>
                      }
                      @if (opened || forceShowMenu) {
                        <td style="width:25px">
                          <mat-icon id="{{getExpandIconId(menu)}}" class="menu-list-icon">add</mat-icon>
                        </td>
                      }
                    </tr>
                  </table>
                </mat-panel-title>
              </mat-expansion-panel-header>
              @if (opened || forceShowMenu) {
                <mat-nav-list>
                  @for (item of menu.items; track item) {
                    <div class="menu-list-option-wrapper">
                      <a mat-list-item class="menu-option menu-list-option" [ngClass]="{'selected': selectedMenu.item.id===item.id}" (click)="onMenuItemSelected(menu, item)">{{item.title}}</a>
                    </div>
                  }
                </mat-nav-list>
              }
            </mat-expansion-panel>
          }
        </div>
      }
    </mat-accordion>
    <div class="menu-option side-bottom" style="bottom:96px" [ngClass]="{'selected': selectedMenu.item.id===settingsMenu.id}" (click)="onMenuItemSelected(settingsMenu)">
      <table width="256px">
        <tr>
          <td style="width:47px">
            <mat-icon class="menu-option-icon">{{settingsMenu.icon}}</mat-icon>
          </td>
          @if (opened || forceShowMenu) {
            <td class="menu-option-text">
              {{settingsMenu.title}}
            </td>
          }
        </tr>
      </table>
    </div>
    <div class="menu-option side-bottom" style="bottom:48px" [ngClass]="{'selected': selectedMenu.item.id===aboutMenu.id}" (click)="onMenuItemSelected(aboutMenu)">
      <table width="256px">
        <tr>
          <td style="width:47px">
            <mat-icon class="menu-option-icon">{{aboutMenu.icon}}</mat-icon>
          </td>
          @if (opened || forceShowMenu) {
            <td class="menu-option-text">
              {{aboutMenu.title}}
            </td>
          }
        </tr>
      </table>
    </div>
    <div class="menu-option side-bottom" style="bottom:0" [ngClass]="{'selected': selectedMenu.item.id===logoutMenu.id}" (click)="logout()">
      <table width="256px">
        <tr>
          <td style="width:47px">
            <mat-icon class="menu-option-icon">{{logoutMenu.icon}}</mat-icon>
          </td>
          @if (opened || forceShowMenu) {
            <td class="menu-option-text">
              {{logoutMenu.title}}
            </td>
          }
        </tr>
      </table>
    </div>
  </div>
}

@if (location==='bottom') {
  <div class="menu-container-bottom">
    <table style="margin:auto;width:50%">
      <tr>
        <td>
          <div class="menu-option" [ngClass]="{'selected': selectedMenu.category.id===0}" (click)="onMenuItemSelected(myreportsMenu)">
            <mat-icon class="menu-option-icon">{{myreportsMenu.icon}}</mat-icon>
          </div>
        </td>
        @for (menu of menus; track menu) {
          <td>
            <div class="menu-option" [ngClass]="{'selected': selectedMenu.category.id===menu.id}" (click)="onMenuItemSelected(menu)">
              <mat-icon class="menu-option-icon">{{menu.icon}}</mat-icon>
            </div>
          </td>
        }
        <td>
          <div class="menu-option" (click)="showSideMenu(0)">
            <mat-icon class="menu-option-icon">menu</mat-icon>
          </div>
        </td>
      </tr>
    </table>
  </div>
}